// Shared "H:MM" duration formatting (no leading zero on the hours) — one
// implementation for Time.js (ms) and ProjectsPage (seconds) instead of a
// per-file copy in each.
import { pad2 } from "./dates";

/** ms → "H:MM", minutes rounded. */
export function fmtDuration(ms) {
  const totalMin = Math.round(ms / 60000);
  return `${Math.floor(totalMin / 60)}:${pad2(totalMin % 60)}`;
}

/** seconds → "H:MM" — the projects page tracks per-project shares in seconds. */
export function fmtDurationSec(seconds) {
  return fmtDuration((seconds || 0) * 1000);
}
